export { createRitualRegistry } from "./registry.js";
export type { RitualRegistryOptions } from "./registry.js";
export { runVortexCli, buildRegistry, resolveRepoRoot, argvToSlash, detectInterruptedGitOp, reclaimStaleGitIndexLock, collectCarryover, tickIsDue, humanCommitDates, attemptArchiveOnlyAutoseal } from "./cli-dispatch.js";
export type { CliIo } from "./cli-dispatch.js";
export {
  applyGlobalSetup,
  recordGlobalSetupDecline,
  inspectGlobalSetup,
  readGlobalInstancePointer,
  isInstanceRoot,
  renderGlobalBlock,
  upsertGlobalBlock,
  globalSettingsPath,
  globalStatePath,
  globalMemoryPath,
  globalSettingsHasHook,
} from "./global-setup.js";
export {
  computeCurateFingerprint,
  runCurateAccept,
  runCurateCandidates,
  runCurateDecline,
  runCuratePreview,
  validateCuratePayload,
} from "./curate-cli.js";
export type {
  CurateActionKind,
  CurateAcceptResult,
  CurateCandidate,
  CurateCandidatesResult,
  CurateDeclineResult,
  CuratePayload,
  CuratePayloadValidation,
  CuratePreviewResult,
} from "./curate-cli.js";
export { curateCommand } from "./commands/curate.js";
export type {
  CurateAnyProposal,
  CurateOptions,
  CurateResult,
} from "./commands/curate.js";
export { recallCommand } from "./commands/recall.js";
export type { RecallOptions } from "./commands/recall.js";
export { createAmbientRecaller } from "./ambient-recall.js";
export type { AmbientRecallFactoryOptions } from "./ambient-recall.js";
export { sessionStartCommand } from "./commands/session-start.js";
export type { SessionStartReport } from "./commands/session-start.js";
export {
  collectSessionStartReport,
  renderSessionStartReport,
  detectWorklogGaps,
  countUncommitted,
  DEFAULT_GAP_WINDOW_DAYS,
  gapWindowSinceArg,
} from "./session-start-report.js";
export type {
  GitPullResult,
  RecentWorklog,
  SessionStartHookReport,
} from "./session-start-report.js";
export { ensureWorklogEntry } from "./worklog-write.js";
export type { EnsureWorklogResult } from "./worklog-write.js";
export { catchUpSessions } from "./catch-up.js";
export type { CatchUpResult, CatchUpOptions } from "./catch-up.js";
export { parseHookStdin, readHookStream, waitForTranscriptStability, liveSkipForFinalize } from "./finalize.js";
export type { HookStdinPayload, HookInputStream, StabilityOptions } from "./finalize.js";
export { runArchiveSync, sweepRawArchive, sweepOrphanTempFiles, archiveRelPath, gitOut, isArchiveOnlyCommit } from "./archive-sync.js";
export type { ArchiveSyncResult, ArchiveCommitSkip, ArchivePushSkip } from "./archive-sync.js";
export {
  ensureVortexHooks,
  migrateVortexHookCommands,
  parseSettings,
  serializeSettings,
  SESSION_START_COMMAND,
  SESSION_END_COMMAND,
  SESSION_TICK_COMMAND,
} from "./ensure-hooks.js";
export type { ClaudeSettings, EnsureHooksResult } from "./ensure-hooks.js";
export {
  parseStatuslineInput,
  renderStatusline,
  collectStatuslineProbes,
  effortMeter,
  formatTokens,
  formatWindow,
  makeBar,
  sniffEffortFromTranscript,
  safeSegment,
  ensureStatusline,
  statuslineCommand,
  isOurStatuslineCommand,
  statuslineCommandIsLite,
  LOCAL_BIN_RELPATH,
  runStatuslineCli,
  teamclaudeConfigPath,
  teamclaudePortFromConfig,
  probeTeamclaudeAccount,
  sessionUsesTeamclaudeProxy,
} from "./statusline.js";
export type {
  StatuslineData,
  StatuslineProbes,
  StatuslineInstallResult,
} from "./statusline.js";
export {
  FAILURES_DIR,
  GUARD_DENIAL_KEY,
  ladderStage,
  isValidFailureKey,
  recordFailure,
  recordGuardDenial,
  scanFailures,
  failureReportSlice,
  runFailureCli,
} from "./failures.js";
export type {
  FailureEntry,
  FailureGroup,
  FailureScan,
  FailureReportSlice,
  LadderStage,
  RecordFailureInput,
  RecordFailureResult,
} from "./failures.js";
export {
  GUARD_WRITE_COMMAND,
  GUARD_WRITE_MATCHER,
  GUARD_FAILURE_ADMISSION_COMMAND,
  GUARD_UNVERIFIED_ASSERTION_COMMAND,
  findControlChar,
  scanToolInput,
  buildDenyDecision,
  guardWriteDecision,
  failureAdmissionDecision,
  unverifiedAssertionDecision,
  lastAssistantTextAndCommands,
  resolveInstanceRoot,
  runGuardCli,
} from "./guard.js";
export type { GuardFinding, AdmissionMatchers, UnverifiedMatchers } from "./guard.js";
export {
  RISKY_RULES,
  riskyRuleFires,
  riskyRuleEnabled,
  buildRiskyAskReason,
  GUARD_RISKY_ACTION_COMMAND,
  GUARD_RISKY_ACTION_MATCHER,
} from "./guard-risky.js";
export type { RiskyRule } from "./guard-risky.js";
export { classifyPromptIntents, buildRouterContext, MEMORY_ROUTER_COMMAND } from "./prompt-router.js";
export { reindexCommand, autoReindexMemory } from "./commands/reindex.js";
export type { ReindexResult } from "./commands/reindex.js";
export { decisionCommand } from "./commands/decision.js";
export type { NewDecisionResult } from "./commands/decision.js";
export { logCommand } from "./commands/log.js";
export type { WorklogAppendResult } from "./commands/log.js";
export { handoffCommand } from "./commands/handoff.js";
export type { HandoffCreateResult } from "./commands/handoff.js";
export {
  createHandoffSkeleton,
  scanHandoffs,
  pruneHandoffs,
  HANDOFF_DIR,
  HANDOFF_ARCHIVE_DIR,
} from "./handoff.js";
export type { HandoffWriteResult, HandoffSummary } from "./handoff.js";
export { agendaCommand } from "./commands/agenda.js";
export {
  collectAgenda,
  renderAgenda,
  extractOpenTasks,
  extractNextUp,
  aggregateHandoff,
} from "./agenda.js";
export type {
  AgendaReport,
  OpenTask,
  OpenDecision,
  CollectAgendaOptions,
} from "./agenda.js";
export { vortexCommand, parseAdoptArgs } from "./commands/vortex.js";
export type {
  VortexResult,
  VortexInitResult,
  VortexHelpResult,
  VortexPlannedResult,
  VortexSyncResult,
  VortexSyncStep,
  VortexSyncStepId,
  VortexSyncStepStatus,
} from "./commands/vortex.js";
export {
  buildOwnershipManifest,
  inspectOwnership,
  isVortexScopedLockfileDiff,
  isVortexScopedPackageDiff,
  ownershipManifestPath,
  repairOwnershipManifest,
  runTemplatesUpdate,
  templateDestRelPath,
  writeOwnershipManifest,
  OWNERSHIP_SCHEMA,
} from "./update.js";
export { changedFrameworkPaths, commitFrameworkPaths, readHeadFileText } from "./git-commit.js";
export type { CommitResult } from "./git-commit.js";
export {
  planMcpWiring,
  planCodexWiring,
  readAddonMcpDeclarations,
  wireAddonMcpServers,
  sanitizeAddonEntry,
  isSafeServerKey,
  mcpAutowireStatePath,
  RESERVED_MCP_KEYS,
  WIRE_TARGETS,
} from "./mcp-autowire.js";
export type { AddonMcpDeclaration, McpConfig, McpWirePlan, CodexWirePlan, WireAddonMcpResult, TargetWireResult, WireTarget, WireTargetId } from "./mcp-autowire.js";
export type {
  OwnershipDiagnosis,
  OwnershipEntry,
  OwnershipManifest,
  UpdateFileAction,
  UpdateFileActionKind,
  VortexUpdateResult,
} from "./update.js";
export {
  buildInstallCommand,
  checkBaseUpdate,
  compareSemver,
  isNewer,
  isStableUpdate,
  queryNpmLatest,
  readInstalledBaseVersion,
} from "./update-check.js";
export type { UpdateCheckResult } from "./update-check.js";
